module.exports = __webpack_public_path__ + "static/media/cart-down.acfe8995.svg";